const ZapsSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8838 3.25L4.35156 13.3333H10.9974L10.111 19.75L17.6432 9.66667H10.9974L11.8838 3.25Z"
      fill="#F8AD21"
    />
  </svg>
);
export default ZapsSvg;
